import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import clsx from 'classnames';

import { useStyles } from '../../hooks';
import styles from './styles';

const IconBackground = ({
  origin = {
    vertical: 'top',
    horizontal: 'right',
  },
  icon: Icon,
  root2 = false
}) => {
  const classes = useStyles(styles);
  
  return (
    <Box 
      className={ root2 ? classes.root2 : clsx(classes.root)
      }
    >
      <Icon className={classes.icon}/>
    </Box>
  );
}

IconBackground.propTypes = {
  origin: PropTypes.shape({
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired,
    horizontal: PropTypes.oneOf(['left', 'right']).isRequired,
  }),
  icon: PropTypes.elementType.isRequired,
}

export default IconBackground;
